import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { GlobalHeaderButtons } from '../../components/PageLayout/GlobalHeaderButtons';
export default function (props, context) {
    return React.createElement('div', { className: classNames(props.className, 'app-header-adj') }, React.createElement(GlobalHeaderButtons, {}), React.createElement('div', { 'className': 'lightbox-header-container' }, React.createElement('div', { 'className': 'lightbox-title-block' }, React.createElement('h1', { 'id': 'PageTitle' }, 'DISCOUNT WORKSHEET'))));
}